// Distâncias no mapa, sem nada do servidor (serve também para as rotinas que
// rodam no GitHub, fora do navegador).

// A estrada é mais comprida que a linha reta: uns 25% a mais, em média.
export const FATOR_DA_ESTRADA = 1.25;

export function kmEstimado(linhaReta) {
  return linhaReta > 0 ? Math.max(10, Math.round((linhaReta * FATOR_DA_ESTRADA) / 10) * 10) : null;
}

// Distância em linha reta (km), igual a app.km_entre() no banco.
export function kmEntre(a, b) {
  const rad = (g) => (g * Math.PI) / 180;
  const s = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lon - a.lon) / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(s));
}
